import React from 'react'
import toastr from '@/lib/notifications'
import $ from 'jquery'
import _ from 'underscore'
import { Input } from '@/components/ui/input'
import EducationNameSearchResult from './results/education_name'

class SearchTertiaryEducationNames extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      searching: false,
      value: this.props.value || '',
      results: []
    }

    this.inputRef = React.createRef()
  }

  componentDidMount() {
    this.lazySearch = _.debounce(this.search, 300)
    this.debouncedOnChange = _.debounce(this.props.onChange, 500)
  }

  onChange = () => {
    const value = this.inputRef.current.value
    this.setState({value: value, searching: value.length > 0})
    this.debouncedOnChange(value)

    if (value.length > 0) {
      this.lazySearch()
    }
  }

  search() {
    const params = {
      search: this.state.value
    }

    $.ajax({
      url: "/api/sales/tertiary_education_names",
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      data: params,
      success: (data) => {
        this.setState({results: data.items})
      },
      error: (data) => {
        if (data && data.responseJSON && data.responseJSON.custom_error_message)
          toastr.error(data.responseJSON.custom_error_message)
        else
          toastr.error('something went wrong')
      }
    })
  }

  onResultClick = (result) => {
    this.setState({searching: false, value: result.name, results: []})
    this.props.onSelect(result.name)
  }

  highlightInput = (e) => {
    e.target.select()
  }

  render() {
    return (
      <div>
        <Input type="text" name="value" placeholder="Tertiary Education" ref={this.inputRef} value={this.state.value} onChange={this.onChange} onClick={this.highlightInput} />
        <ul className="m-0 mt-1 max-h-[220px] list-none overflow-y-auto p-0">
          {this.state.searching ?
            _.map(this.state.results, (result) => {
              return (
                <EducationNameSearchResult key={result.id} result={result} onClick={this.onResultClick}/>
              )
            })
            : null
          }
        </ul>
      </div>
    )
  }
}

export default SearchTertiaryEducationNames
